import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { Context as PropertyContext } from "../../context/property.context";
import { ThumbDownAltOutlined } from "@material-ui/icons";

const columns = [
  { id: "fundName", label: "Fund Name" },
  { id: "grossTax", label: "Gross Tax", align: "right" },
  {
    id: "exemptValue",
    label: "Exemption Value",
    align: "center",
  },
  {
    id: "taxExemption",
    label: "Tax Exemption",
    align: "center",
  },
  {
    id: "netTax",
    label: "Net Tax",
    align: "right",
  },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
    overflowX: "auto",
  },
  container: {
    // maxHeight: 540,
  },
});

export default function TaxBreakdown(props) {
  const classes = useStyles();
  const { state } = useContext(PropertyContext);

  const { id } = useParams();

  useEffect(() => {
    console.log("pROPERTY STATE", state.taxBill);
    console.log("Is array", Array.isArray(state.taxBill.taxBreakdown));
  });

  function renderTaxBill() {
    if (Array.isArray(state.taxBill.taxBreakdown)) {
      return state.taxBill.taxBreakdown.map((item, index) => {
        return (
          <TableRow hover role="checkbox" tabIndex={-1} key={index}>
            {columns.map((column) => {
              const value = item[column.id];

              return (
                <TableCell key={column.id} align={column.align}>
                  {value}
                </TableCell>
              );
            })}
          </TableRow>
        );
      });
    } else {
      return null;
    }
  }

  function renderTaxBillMobile() {
    if (Array.isArray(state.taxBill.taxBreakdown)) {
      return state.taxBill.taxBreakdown.map((item, index) => {
        return (
          <td>
            {columns.map((column) => {
              const value = item[column.id];

              return value;
            })}
          </td>
        );
      });
    } else {
      return null;
    }
  }

  return (
    <Paper className={classes.root} elevation={0}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead style={{ background: "#ECF1F5 !important" }}>
            <TableRow style={{ background: "#ECF1F5" }}>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, background: "#ECF1F5" }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{renderTaxBill()}</TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
